import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  useLocation,
} from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import { trackVisit } from "./utils/trackVisit";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Loader from "./components/Loader";

import Home from "./pages/Home";
import Categories from "./pages/Categories";
import CategoryPage from "./pages/CategoryPage";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import ProductDetails from "./pages/ProductDetails";
import OrderSuccess from "./pages/OrderSuccess";
import AllProducts from "./pages/AllProducts";
import NotFound from "./pages/NotFound";

// The admin panel (incl. recharts, a large charting dependency used only
// by AdminInsights) is only ever used by the logged-in admin - loading it
// lazily keeps it out of the bundle every anonymous shop visitor downloads.
// It's ONE lazy boundary for the whole section (see AdminRoutes.js) rather
// than one per page, so the admin pages' JS+CSS load together as a single
// chunk instead of racing/colliding across several independently-loaded ones.
const AdminRoutes = lazy(() => import("./pages/admin/AdminRoutes"));
function ShopLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
  trackVisit();
      }, []);
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.08 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [location.pathname]);

  return (
    <>
      <Navbar transparent={isHome} />
      <CartDrawer />

      <div className={`page-shell${isHome ? " page-shell--home" : ""}`}>
        <Outlet />
      </div>

      <Footer />
      <FloatingWhatsApp />
    </>
  );
}

function AdminFallback() {
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
      <Loader message="Loading admin..." />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Suspense fallback={<AdminFallback />}>
      <Routes>
        {/* Shop routes */}
        <Route element={<ShopLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/c/:id" element={<CategoryPage />} />
          <Route path="/c/:id/:childId" element={<CategoryPage />} />
          <Route path="/categories/:id" element={<CategoryPage />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-success/:orderId" element={<OrderSuccess />} />
          <Route path="/AllProducts" element={<AllProducts />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Admin section - one consolidated lazy chunk, see AdminRoutes.js */}
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;